import { render, staticRenderFns } from "./PcCurrentInfo.vue?vue&type=template&id=83620e8e&scoped=true&"
import script from "./PcCurrentInfo.vue?vue&type=script&lang=js&"
export * from "./PcCurrentInfo.vue?vue&type=script&lang=js&"
import style0 from "./PcCurrentInfo.vue?vue&type=style&index=0&id=83620e8e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83620e8e",
  null
  
)

/* custom blocks */
import block0 from "./PcCurrentInfo.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports